const SupplierIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
    >
      <g
        id="Group_94060"
        data-name="Group 94060"
        transform="translate(-30 -100)"
      >
        <g
          id="Group_93058"
          data-name="Group 93058"
          transform="translate(0 -184)"
          opacity="0"
        >
          <g
            id="Business_s_Icon"
            data-name="Business's_Icon"
            transform="translate(-1790 95)"
            opacity="0"
          >
            <g
              id="Rectangle_24795"
              data-name="Rectangle 24795"
              transform="translate(1820 189)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
              opacity="0"
            >
              <rect width="23" height="23" stroke="none" />
              <rect x="0.5" y="0.5" width="22" height="22" fill="none" />
            </g>
            <g id="team-leader" transform="translate(1820 189)">
              <g id="Team_Leader_1_" transform="translate(1.328)">
                <g
                  id="Group_92575"
                  data-name="Group 92575"
                  transform="translate(0 2.745)"
                >
                  <path
                    id="Path_140327"
                    data-name="Path 140327"
                    d="M32.657,67.313a2.657,2.657,0,1,1,2.657-2.657A2.659,2.659,0,0,1,32.657,67.313Z"
                    transform="translate(-30 -62)"
                    fill="#fff"
                  />
                </g>
                <g
                  id="Group_92576"
                  data-name="Group 92576"
                  transform="translate(14.7 2.745)"
                >
                  <path
                    id="Path_140328"
                    data-name="Path 140328"
                    d="M364.657,67.313a2.657,2.657,0,1,1,2.657-2.657A2.659,2.659,0,0,1,364.657,67.313Z"
                    transform="translate(-362 -62)"
                    fill="#fff"
                  />
                </g>
                <g
                  id="Group_92577"
                  data-name="Group 92577"
                  transform="translate(6.686)"
                >
                  <path
                    id="Path_140329"
                    data-name="Path 140329"
                    d="M184.321,6.642a3.321,3.321,0,1,1,3.321-3.321A3.325,3.325,0,0,1,184.321,6.642Z"
                    transform="translate(-181)"
                    fill="#fff"
                  />
                </g>
                <path
                  id="Path_140330"
                  data-name="Path 140330"
                  d="M156.313,151.516V156.1a.664.664,0,0,1-1.328,0v-4.582A4.642,4.642,0,0,0,151,156.1v3.985a.664.664,0,0,0,.664.664h1.488l.507,6.122a.664.664,0,0,0,.662.608h2.657a.664.664,0,0,0,.662-.608l.507-6.122h1.488a.664.664,0,0,0,.664-.664V156.1A4.642,4.642,0,0,0,156.313,151.516Z"
                  transform="translate(-145.642 -144.807)"
                  fill="#fff"
                />
              </g>
              <path
                id="Path_140331"
                data-name="Path 140331"
                d="M5.313,189.306v-3.985a5.9,5.9,0,0,1,.7-2.747A3.942,3.942,0,0,0,3.985,182,3.989,3.989,0,0,0,0,185.985v3.321a.664.664,0,0,0,.664.664h.727l.6,6.044a.664.664,0,0,0,.661.6H5.313a.664.664,0,0,0,.661-.6l.491-4.908A1.99,1.99,0,0,1,5.313,189.306Z"
                transform="translate(0 -173.941)"
                fill="#fff"
              />
              <path
                id="Path_140332"
                data-name="Path 140332"
                d="M372.451,185.985A3.989,3.989,0,0,0,368.466,182a3.942,3.942,0,0,0-2.028.574,5.9,5.9,0,0,1,.7,2.747v3.985a1.991,1.991,0,0,1-1.152,1.8l.491,4.908a.664.664,0,0,0,.661.6h2.657a.664.664,0,0,0,.661-.6l.6-6.044h.727a.664.664,0,0,0,.664-.664Z"
                transform="translate(-349.781 -173.941)"
                fill="#fff"
              />
            </g>
          </g>
          <g id="credit-card" transform="translate(30 205.18)">
            <g
              id="Group_93057"
              data-name="Group 93057"
              transform="translate(0 82.82)"
            >
              <path
                id="Path_140371"
                data-name="Path 140371"
                d="M21.312,82.82H1.688A1.69,1.69,0,0,0,0,84.508V96.691a1.69,1.69,0,0,0,1.688,1.688H21.312A1.69,1.69,0,0,0,23,96.691V84.508A1.69,1.69,0,0,0,21.312,82.82ZM7.075,92.951h2.28a.5.5,0,0,1,0,.991H7.075a.5.5,0,0,1,0-.991ZM2.142,87.983a.5.5,0,0,1,.5-.5H5.6a.5.5,0,0,1,.5.5v2.145a.5.5,0,0,1-.5.5H2.637a.5.5,0,0,1-.5-.5Zm.5,4.968h2.28a.5.5,0,0,1,0,.991H2.637a.5.5,0,0,1,0-.991Zm8.14,3.193H2.637a.5.5,0,0,1,0-.991h8.14a.5.5,0,0,1,0,.991Zm3.016-2.2h-2.28a.5.5,0,0,1,0-.991h2.28a.5.5,0,0,1,0,.991Zm4.438,0h-2.28a.5.5,0,0,1,0-.991h2.28a.5.5,0,0,1,0,.991Zm2.132-7.235H14.985a.5.5,0,1,1,0-.991h5.378a.5.5,0,0,1,0,.991Z"
                transform="translate(0 -82.82)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
        <g id="parcel" transform="translate(30 103)">
          <path
            id="Path_140541"
            data-name="Path 140541"
            d="M11.994,224.115l-1.95-.488a.671.671,0,0,0-.7.245L7.869,225.82l-1.48-1.951a.671.671,0,0,0-.714-.263l-2.33.6A4.408,4.408,0,0,0,0,228.508v2.1a.674.674,0,0,0,.674.674H12.108a2.018,2.018,0,0,1-.114-.67Zm0,0"
            transform="translate(0 -213.541)"
            fill="#fff"
            fill-rule="evenodd"
          />
          <path
            id="Path_140542"
            data-name="Path 140542"
            d="M389.8,181.376l.41.206V180h-1.42v1.582l.406-.2A.67.67,0,0,1,389.8,181.376Zm0,0"
            transform="translate(-371.327 -171.914)"
            fill="#fff"
            fill-rule="evenodd"
          />
          <path
            id="Path_140543"
            data-name="Path 140543"
            d="M305.984,180h-2.094v2.671a.674.674,0,0,1-1.031.571l-1.027-.516-1.084.545a.673.673,0,0,1-.971-.6l0-2.671h-2.1a.674.674,0,0,0-.674.674v8.311a.674.674,0,0,0,.674.674h8.311a.674.674,0,0,0,.674-.674v-8.311A.674.674,0,0,0,305.984,180Zm0,0"
            transform="translate(-283.658 -171.914)"
            fill="#fff"
            fill-rule="evenodd"
          />
          <path
            id="Path_140544"
            data-name="Path 140544"
            d="M83.246,4.537A4.537,4.537,0,1,1,78.709,0,4.537,4.537,0,0,1,83.246,4.537Zm0,0"
            transform="translate(-70.84)"
            fill="#fff"
            fill-rule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
};

export default SupplierIcon;
